// extracted by mini-css-extract-plugin
export default {"accounts":"ACFXvc","container":"CPoBNa","avatar":"w3oxHn","information":"DryJbq","number":"bN3byo","nickname":"At8Unn"};